import { buildQueryKey } from '@webapp/core/utils/react-query/buildQueryKey'
import { expenseRepository } from '../data-access/repositories/ExpenseRepository'

const base = ['expense']

export const expenseQueryConfig = {
  drafts: () => ({
    queryKey: buildQueryKey([...base, 'drafts']),
    queryFn: () => expenseRepository.getDrafts(),
  }),
  requestFormData: () => ({
    queryKey: buildQueryKey([...base, 'request-form-data']),
  }),
}
